import '@symfony/ux-live-component/dist/live.min.css';
export default {
  'live': import(/* webpackMode: "eager" */ '@symfony/ux-live-component/dist/live_controller.js'),
  'symfony--ux-turbo--turbo-core': import(/* webpackMode: "eager" */ '@symfony/ux-turbo/dist/turbo_controller.js'),
};